const resources = {
    showPasswordLinkAriaLabel: 'Show password text',
    hidePasswordLinkAriaLabel: 'Hide password text'
};

module.exports = function getResource(label, vars = []) {
    return resources[label];
};
